import PropTypes from 'prop-types';
import styles from './Footer.module.scss';
import HeadingWithLinks from '../navigation/HeadingWithLinks';

export default function Footer({
  lists = [],
  logo = null,
  phoneNumber = null,
  address = null,
  socials = null,
  accreditations = null,
  bottomLinks = null,
  copyright = null,
  privacy = null,
}) {
  return (
    <footer id="footer" className={styles.footer}>
      <div className={styles.footer__container}>
        <div className={styles.footer__top}>
          <div className={styles.footer__logo}>{logo}</div>
          <div className={styles.footer__text}>
            <div className={styles.footer__info}>
              <div className={styles['footer__info-item']}>
                {phoneNumber.icon}
                {phoneNumber.label}
              </div>
              <div className={styles['footer__info-item']}>
                {address}
              </div>
            </div>
            <div className={styles.footer__social}>
              {socials}
            </div>
          </div>
        </div>
        <div className={styles['footer__info-mobile']}>
          <div className={styles['footer__info-item']}>
            {phoneNumber.icon}
            {phoneNumber.label}
          </div>
          <div className={styles['footer__info-item']}>
            {address}
          </div>
        </div>
        <hr />
        <div className={styles.footer__grid}>
          {lists?.map((list, index) => (
            <HeadingWithLinks
              key={index}
              heading={list?.heading?.toUpperCase()}
              items={list?.items}
              type="footer"
            />
          ))}
        </div>
        <div className={styles.footer__logos}>
          {accreditations}
        </div>
        <hr />
        <div className={styles.footer__bottom}>
          <div className={styles.footer__copyright}>
            {copyright}
          </div>
          <ul className={styles['footer__bottom-links']}>
            {bottomLinks?.map((link, index) => (
              <li key={index}>
                {link}
              </li>
            ))}
            <li className={styles.footer__privacy}>
              {privacy}
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  lists: PropTypes.arrayOf(PropTypes.shape({
    heading: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.node).isRequired,
  })).isRequired,
  logo: PropTypes.node.isRequired,
  phoneNumber: PropTypes.shape({
    icon: PropTypes.node.isRequired,
    label: PropTypes.node.isRequired,
  }).isRequired,
  address: PropTypes.node.isRequired,
  socials: PropTypes.node.isRequired,
  accreditations: PropTypes.node.isRequired,
  bottomLinks: PropTypes.node.isRequired,
  copyright: PropTypes.node.isRequired,
  privacy: PropTypes.node.isRequired,
};
